@let memberDataValue = memberData();

@if (memberDataValue) {
  <div class="form-container">
    @switch (formVariant()) {
      @case ('basic') {
        <ng-container *ngTemplateOutlet="basicFormTemplate" />
      }
      @case ('advanced') {
        <ng-container *ngTemplateOutlet="advancedFormTemplate" />
      }
    }
  </div>
} @else {
  <rt-spinner />
}

<ng-template #basicFormTemplate>
  <div class="container basic-form">
    <rt-avatar
      [type]="!!memberDataValue.avatarThumbUrl ? 'image' : 'initials'"
      [imageSrc]="memberDataValue.avatarThumbUrl ?? null"
      [fullName]="fullName()"
      size="small"
      context="admin"
    />
    <div class="details-container">
      <span class="name">{{ fullName() }}</span>
      <span class="email">{{ memberDataValue.email }}</span>
    </div>
  </div>
</ng-template>

<ng-template #advancedFormTemplate>
  <div class="container advanced-form">
    <div class="details-container">
      <rt-avatar
        [type]="!!memberDataValue.avatarThumbUrl ? 'image' : 'initials'"
        [imageSrc]="memberDataValue.avatarThumbUrl ?? null"
        [fullName]="fullName()"
        size="small"
        context="admin"
      />
      <span class="name">{{ fullName() }}</span>
    </div>
    <div class="invite-method-container" [class.open]="displayAdvancedForm()">
      <rt-form-field class="invite-method">
        <div class="invitation-type-label-container">
          <rt-label
            >{{
              'tlc.members.invite_existing_members.member_section.member_details_form.import_csv'
                | translate
            }}
          </rt-label>
          <div class="import-csv" (click)="navigateToCsvImport()">
            <rt-icon name="file-account" size="small-x" />
            <span>{{
              'tlc.members.invite_existing_members.member_section.member_details_form.import_csv'
                | translate
            }}</span>
          </div>
        </div>
        <tlc-invite-method-select [inviteMethodControl]="$any(parentForm().get('inviteMethod'))" />
      </rt-form-field>
    </div>

    <div
      class="email-invite-method-container"
      [class.open]="inviteMethodControl.value === InviteMethod.Email"
      [attr.margin-top-small]="displayAdvancedForm() || null"
    >
      <div class="email-invite-method">
        <rt-infobox
          class="infobox"
          type="information"
          [isDismissible]="false"
          iconName="info-outline"
          [heading]="
            'tlc.members.invite_existing_members.member_section.member_details_form.infobox.heading'
              | translate
          "
        >
          <span>{{
            'tlc.members.invite_existing_members.member_section.member_details_form.infobox.subheading'
              | translate
          }}</span>
        </rt-infobox>

        <div class="controls-container">
          <rt-form-field class="email-field" [required]="true">
            <rt-label
              >{{
                'tlc.members.invite_existing_members.member_section.member_details_form.email.label'
                  | translate
              }}
            </rt-label>
            <rt-input
              [rtFormError]="emailFieldErrors"
              [placeholder]="
                'tlc.members.invite_existing_members.member_section.member_details_form.email.placeholder'
                  | translate
              "
              [formControl]="$any(parentForm().get('email'))"
              type="email"
              rtProtectedControl
            />
          </rt-form-field>
          <rt-form-field class="first-name-field">
            <rt-label
              >{{
                'tlc.members.invite_existing_members.member_section.member_details_form.first_name.label'
                  | translate
              }}
            </rt-label>
            <rt-input
              [placeholder]="
                'tlc.members.invite_existing_members.member_section.member_details_form.first_name.placeholder'
                  | translate
              "
              [formControl]="$any(parentForm().get('firstName'))"
              rtProtectedControl
            />
          </rt-form-field>
          <rt-form-field class="last-name-field">
            <rt-label
              >{{
                'tlc.members.invite_existing_members.member_section.member_details_form.last_name.label'
                  | translate
              }}
            </rt-label>
            <rt-input
              [placeholder]="
                'tlc.members.invite_existing_members.member_section.member_details_form.last_name.placeholder'
                  | translate
              "
              [formControl]="$any(parentForm().get('lastName'))"
              rtProtectedControl
            />
          </rt-form-field>
        </div>
      </div>
    </div>
  </div>
</ng-template>
